import React from "react";
import { business } from "../data/content";

/**
 * BookLink - external anchor to the Square booking URL.
 * Drop-in replacement for a "Book Now" <Link>.
 */
export default function BookLink({
  children,
  className = "btn-petal",
  ...rest
}) {
  return (
    <a
      href={business.bookingUrl}
      target="_blank"
      rel="noreferrer noopener"
      className={className}
      {...rest}
    >
      {children}
    </a>
  );
}
